<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <!-- TABLA DOCUMENTO -->
          <template>
            <div v-if="loading">
              <loading></loading>
            </div>
            <grid-digitacion
              :key="gridDocumento"
              :rowsTable="rowsTable"
              :contratoId="contratoId"
            ></grid-digitacion>
            <!-- <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text">En construcción</v-toolbar-title>
            </v-toolbar> -->
          </template>
          <!-- TABLA DOCUMENTO -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridDigitacion from "@/modules/captura/views/seguimiento/digitacion/GridDigitacion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "digitacion",

  components: {
    GridDigitacion,
    Loading,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      loading: false,
      rowsTable: [20],
      contratoId: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      gridDocumento: 20,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
